<template>
    <div class="modal" v-if="product !== null">
        <div class="product-card product-card-modal" :class="{'combo-modal': product.entity === 'Combo'}">
            <div v-if="catalogElement.pagination !== undefined" class="button-navigate button-prev"
                 @click="getPrev(catalogElement.pagination)">
                <span class="pp-icon pp-icon-arrow"></span>
            </div>
            <div class="button-product-card-close" @click="closeModal()">
                <span class="pp-icon pp-icon-close"></span>
            </div>
            <ComboModalBody :combo="product" v-if="product.entity === 'Combo'"></ComboModalBody>
            <div v-else class="product-card-modal-body">
                <div class="col col-left">
                    <Tags v-bind:product="product" :key="product.id"></Tags>
                    <div class="product-card-title product-card-modal-title">
                        {{ product.title }}
                    </div>
                    <div class="product-card-modal-image" :style="{ backgroundImage: `url(${productImage})` }"></div>
                    <div class="col-footer">
                        <div class="product-card-modal-price">{{ getPrice(product, selectedOffer.id) }}&#8381;</div>
                        <div class="product-card-like" @click="setVote" :class="{'button-processing': voteButtonProcessing}">
                            <span class="like-qnt">{{ product.votes }}</span>
                            <span class="like-button pp-icon" :class="[ userVote > 0 ? 'pp-icon-heart-full' : 'pp-icon-heart']"></span>
                        </div>
                    </div>
                </div>
                <div class="col col-right">
                    <div class="col-right-body scroll-black">
                        <div class="product-card-modal-description" v-show="product.description">{{ product.description }}</div>
                        <div class="property" v-show="product.only_pickup">
                            <div class="property-title">{{ phrases.TEXT_ONLY_PICKUP }}</div>
                        </div>

                        <div class="property" v-show="product.consist">
                            <span class="property-title">{{phrases.PRODUCT_CONSIST}}</span>
                            <span class="property-value">{{ consist }}</span>
                        </div>

                        <div class="product-card-modal-buttons" v-if="isPizza && product.offers.length > 0">
                          <div v-for="offer in product.offers" :key="offer.id" @click="choosePizzaSize(offer)"
                               class="product-card-modal-choose-button button-sm button-pizza-size disabled-option-dough" :class="{'active': selectedOffer.id === offer.id}">
                            <span class="button-note">{{offer.size}}{{phrases.PRODUCT_PIZZA_DIAMETR_UNIT}}</span>
                            <div class="separate"></div>
                            <span class="button-note">≈{{ offer.weight }}{{ phrases.PRODUCT_WEIGHT_GR }}</span>
                          </div>
                        </div>

                        <div class="product-card-option product-card-modal-option"
                             v-if="isPizza && selectedOffer.dough_available === true">
                          <div class="product-card-option-title option-dough">{{ optionsTitle(product) }}</div>
                          <div class="product-card-option-list option-dough option-list-sm">
                            <div class="product-card-option-button size-sm"
                                 :class="{active: isThinDough}" @click="changeDoughType(true)">{{ doughTitle('thin')}}</div>
                            <div class="product-card-option-button size-sm"
                                 :class="{active: !isThinDough}" @click="changeDoughType(false)">{{ doughTitle('thick')}}</div>
                          </div>
                        </div>

                        <div class="product-card-option product-card-modal-option" v-if="!isPizza && product.offers.length > 0">
                          <div class="product-card-option-title">{{ optionsTitle(product) }}</div>
                          <div class="product-card-option-list option-list-sm">
                            <div class="product-card-option-button" v-for="offer in product.offers" :key="offer.id"
                                 @click="chooseOffer(offer)"
                                 :class="{active: selectedOffer.id === offer.id, 'blocked': !offer.available}">
                              {{ offer.title }}
                            </div>
                          </div>
                        </div>

                        <div v-if="isPizza" class="property">
                            <span class="property-title">{{phrases.TEXT_WEIGHT}}: </span>
                            <span class="property-value">{{ getPizzaWeight(product, selectedOffer.id) }} {{ phrases.PRODUCT_WEIGHT_GR }}</span>
                          </div>

                        <div v-else-if="getWeight(product, selectedOffer.id) !== null && isDrinks" class="property">
                            <span class="property-title">{{ phrases.TEXT_VOLUME }}</span>
                            <span class="property-value">{{ getWeight(product, selectedOffer.id) }} {{ phrases.PRODUCT_VOLUME_L_DOT }}</span>
                        </div>

                        <div v-else-if="getWeight(product, selectedOffer.id) !== null" class="property">
                            <span class="property-title">{{ phrases.TEXT_WEIGHT }}</span>
                            <span class="property-value">{{ getWeight(product, selectedOffer.id) }} {{ phrases.PRODUCT_WEIGHT_GR_DOT }}</span>
                        </div>

                        <div v-show="product.quantity !== null" class="property">
                            <span class="property-title">{{ phrases.TEXT_AMOUNT }}</span>
                            <span class="property-value">{{ product.quantity }}</span>
                        </div>

                        <div v-if="product.nutritional !== null" class="property">
                            <div class="property-title">{{phrases.PRODUCT_NUTRITIONAL_VALUE}}</div>
                            <div class="property-value">{{nutritional}}</div>
                        </div>
                    </div>

                    <div v-if="!product.available || (this.selectedOffer.available !== undefined && !this.selectedOffer.available)" class="button-unavailable">{{phrases.PRODUCT_UNAVAILABLE}}</div>

                    <div v-else class="product-card-button-action product-card-button-action"
                         :class="['goal-add-product-to-basket', addedToBasket ? 'active' : '']" @click="addToBasket()">
                        <span class="pp-icon pp-icon-basket-move"></span>
                        <span class="product-card-button-action-title">{{phrases.PRODUCT_CARD_BUTTON_ADD_TO_CARD}}</span>
                    </div>
                </div>
            </div>
            <div v-if="catalogElement.pagination !== undefined" class="button-navigate button-next"
                 @click="getNext(catalogElement.pagination)">
                <span class="pp-icon pp-icon-arrow"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ProductCard from "./ProductCard.vue";
    import ComboUtils from "@/components/combos/ComboUtils.vue";
    import Tags from "@/components/product/Tags.vue";
    import ComboModalBody from "@/components/combos/ComboModalBody.vue";

    export default {
        name: "ProductLargeCard",
        data: function(){
            return {
                isSelectedSauce: false,
                selectedSauce: {},
            };
        },
        computed:{
            ...mapGetters('catalog', {
                catalogElement: 'getSelectedProductLargeCard',
                productList: 'getProductList',
                products: 'getProducts',
                groups: 'getGroups',
            }),
            nutritional: function () {
                return (this.selectedOffer.nutritional !== null && this.selectedOffer.nutritional !== undefined)
                    ? this.selectedOffer.nutritional : this.product.nutritional;
            },
            product: function (){
              return (this.catalogElement !== null) ? this.catalogElement.element : null;
            }
        },
        methods: {
            closeModal: function () {
                const component = this;
                component.selectedProductOffer = null;
                component.$store.commit('catalog/setSelectedProductLargeCard', null);
                component.finishComboSet();
            },
            getPrev: function (pagination) {
                let groupIndex = pagination.groupIndex;
                let productIndex = pagination.productIndex - 1;

                groupIndex = (productIndex === -1) ?
                    ((groupIndex - 1 < 0) ? this.groups.length - 1 : (groupIndex - 1)) : groupIndex;

                const group = this.groups[groupIndex];
                const groupProducts = this.products[group.id];

                if(productIndex === -1) {
                  productIndex = groupProducts.length - 1;
                }

                this.getProduct({
                  'element': groupProducts[productIndex],
                  'pagination': {'groupIndex': groupIndex, 'productIndex': productIndex, 'groupProductCount': groupProducts.length}
                });
            },
            getNext: function (pagination) {
                let groupIndex = pagination.groupIndex;
                let productIndex = pagination.productIndex + 1;
                if(productIndex === pagination.groupProductCount) {
                  groupIndex = (groupIndex + 1 < this.groups.length) ? groupIndex + 1 : 0;
                  productIndex = 0;
                }

                const group = this.groups[groupIndex];
                const groupProducts = this.products[group.id];
                this.getProduct({
                  'element': groupProducts[productIndex],
                  'pagination': {'groupIndex': groupIndex, 'productIndex': productIndex, 'groupProductCount': groupProducts.length}
                });
            },
            getProduct: function (catalogElement){
              this.$store.commit('catalog/setSelectedProductLargeCard', catalogElement);
              this.setMeta(catalogElement.element);
              this.addAnchor(catalogElement.element);
              switch(catalogElement.element.entity){
                case "Combo":
                  this.initCombo(catalogElement.element);
                  break;
                default:
                  this.setProductData(catalogElement.element);
                  break;
              }
            },
            setProductData: function (product){
              if(product.offers.length > 1){
                this.chooseOffer(product.offers[0]);
              }else{
                this.chooseProduct();
              }
            }
        },
        mixins: [ProductCard, ComboUtils],
        components: {
          ComboModalBody,
          Tags
        },
    }
</script>

<style scoped lang="scss">
  .product-card-option-button{
    &.blocked{
      cursor: default;
      background: #809f36;
      color: #ffffff;
      opacity: 0.7;
      &:hover{
        background: #809f36;
        color: #fff;
      }
    }
    &.active{
      background: #000;
      color: #fff;
      border-color: #000;
    }
  }
</style>
